import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { addAppLog } from './actions/appLogs';
import { addLog } from './actions/rethink';
import { addFBNetworkLog } from "./actions/fbNetwork-logs";
import { addException } from './actions/exceptions';
import { updateChecks } from "./actions/sync-actions";
import { updateLabels } from "./slice/labelsSlice";
import { updateTheme } from "./slice/themeSlice";

import rootReducer from "./reducers";

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: "root",
  storage,
  keyPrefix: "",
  whitelist: ['storeTypesPersist', 'notificationsTypesPersist', 'checkSortReducer', 'teamshareFilterPersist', 'fbCheckFilters'], // ADD REDUCERS HERE
};

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  pReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);

export function dispatchServerAppLogs(logLevel: String, message: any) {
  store.dispatch(addAppLog({ logLevel, message }));
}

export function dispatchRethinkDBLogs(logLevel: string, message: any) {
  store.dispatch(addLog({ logLevel, message }));
}

export function dispatchFBNetworkLogs(log: any) {
  store.dispatch(addFBNetworkLog(log));
}

export function dispatchExceptionLogs(message: String, stackTrace: any) {
  store.dispatch(addException({ message, stackTrace }));
}

export function dispatchUpdateChecks(checks: any) {
  store.dispatch(updateChecks(checks));
}

export function dispatchLabelsAction(labels) {
  store.dispatch(updateLabels(labels));
}

export function dispatchThemeUpdateAction(theme) {
  store.dispatch(updateTheme(theme));
}
